
const public_api = {
  submit_internships: "/internship/submit",
  get_global_config: "/lushai_company/website-config",
  get_job_openings: "/career/get-job-openings",
  submit_job_application: "/career/submit-job-application",
  blogs: "/blogs",
  tution: {
    tution_registration_form_options: "/education/tution-registration-form-options",
    tution_registration: "/education/tution-registration",
    tution_reg_details: (id) => `/education/tution-registration-details/${id}`
  },
  cms: {
    get_home_items: "/cms/api/home-page",
    get_services_items: "/cms/api/services-page",
    get_about_items: "/cms/api/about-us-page",
    get_blogs: "/cms/api/blogs",
    contact_us_data : "/cms/api/contact-us-page",
    get_career_openings: "/cms/api/career-openings/active",
    get_internship_program: "/cms/api/internship-program",
  },
  ai_chat: "/ai/chat",
}

const admin_api = {
  get_interns: "/internship/applicants",
  get_job_applicants: "/career/get-job-applicants",
  blogs: {
    get_authors: "/blogs/form_options/authors",
    blogs_crud: "/blogs",
  },
  education: {
    tution_registrations: "/admin/education/registrations",
    tution_registrations_subj_filters: "/admin/education/registrations-filters",
    export_registration : "/admin/education/export-registration",
  }
}

Object.freeze(public_api);
Object.freeze(admin_api);

export {
  public_api,
  admin_api
}
